import { render } from "./Performance.vue?vue&type=template&id=51481221"
import script from "./Performance.vue?vue&type=script&lang=js"
export * from "./Performance.vue?vue&type=script&lang=js"
script.render = render

export default script